var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConverticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 22q-.425 0-.712-.288T3 21t.288-.712T4 20h1.55q-1.2-.575-1.937-1.7t-.738-2.55q0-1.975 1.388-3.363T7.625 11q.425 0 .713.288t.287.712t-.288.713t-.712.287q-1.125 0-1.937.8t-.813 1.95q0 .975.6 1.725t1.525.95V17q0-.425.288-.712T8 16t.713.288T9 17v4q0 .425-.288.713T8 22zm9-6h8v3q0 .825-.587 1.413T19 21h-6zm0-2V9h8v5zM3 7V5q0-.825.588-1.412T5 3h14q.825 0 1.413.588T21 5v2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConverticon);
export default __webpack_public_path__ + "static/media/converticon.ea0c18c50890647d3e1c123333416492.svg";
export { ForwardRef as ReactComponent };